import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import Heading from '@bibliocommons/heading';

import ClearFacets from 'app/components/shared/Facets/ClearFacets';
import RelatedDisplayBibs from 'app/components/events/RelatedDisplayBibs';
import displayBibShape from 'app/shapes/displayBib';

import './EmptyEventsSearch.scss';

export default function EmptyEventsSearch({ currentPageHref, displayBibs, searchTerm, trackCatologTitleClick }) {
  return (
    <div className="cp-empty-events-search">
      <Heading tagName="h2" size="medium">
        <FormattedMessage id="empty_events_search_heading" />
      </Heading>
      <FormattedMessage id="empty_events_search_description" tagName="p" />
      <ClearFacets>
        <FormattedMessage id="explore_all_events" />
      </ClearFacets>
      {displayBibs.length > 0 && (
        <div className="catalog-results-bib-row">
          <RelatedDisplayBibs
            displayBibs={displayBibs}
            currentPageHref={currentPageHref}
            headingId="events.catalog.results"
            searchTerm={searchTerm}
            trackCatalogTitleClick={trackCatologTitleClick}
          />
        </div>
      )}
    </div>
  );
}

EmptyEventsSearch.propTypes = {
  currentPageHref: PropTypes.string.isRequired,
  displayBibs: PropTypes.arrayOf(displayBibShape),
  searchTerm: PropTypes.string,
  trackCatologTitleClick: PropTypes.func.isRequired
};
